import { AxiosHttpClientAdapter } from '@/core/services/network/infra/adapters/axios.adapter';
import { getApiBaseUrl } from '@/core/utils/apiUtils';
import type { StoreGiftCardRepository } from '../../domain/interfaces/StoreGiftCardRepository';
import type { GiftCardFormData, NddAvailabilityResult, PhysicalGiftCardConfig } from '../../domain/models/storeGiftCard.types';
import type { ApiNddAvailabilityResponse, ApiPhysicalGiftCardConfigResponse } from '../dto/storeGiftCard.dto';
import { adaptNddAvailabilityToDomain, adaptConfigToDomain } from '../mappers/storeGiftCard.mapper';

const NDD_AVAILABILITY_ENDPOINT = '/carrier/gift-card-carrier-availability';
const GIFT_CARD_ORDER_ENDPOINT = '/order';
const PHYSICAL_GIFT_CARD_CONFIG_ENDPOINT = '/physical-gift-card';

export class StoreGiftCardAdapter implements StoreGiftCardRepository {
  private httpClient = new AxiosHttpClientAdapter({
    baseURL: getApiBaseUrl(),
  });

  async getGiftCardConfig(): Promise<PhysicalGiftCardConfig> {
    const response = await this.httpClient.get<ApiPhysicalGiftCardConfigResponse>(PHYSICAL_GIFT_CARD_CONFIG_ENDPOINT);
    return adaptConfigToDomain(response);
  }

  async checkNddAvailability(pincode: string): Promise<NddAvailabilityResult> {
    const response = await this.httpClient.get<ApiNddAvailabilityResponse>(
      `${NDD_AVAILABILITY_ENDPOINT}?pincode=${encodeURIComponent(pincode)}`
    );
    return adaptNddAvailabilityToDomain(response);
  }

  // native form submission
  submitGiftCardOrder(formData: GiftCardFormData, customizationId: string): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = GIFT_CARD_ORDER_ENDPOINT;
    form.style.display = 'none';

    const payload: Record<string, string> = {
      amount: formData.amount.toString(),
      rfname: formData.rfname,
      rmobile: formData.rmobile,
      remail: formData.remail,
      cremail: formData.cremail,
      pincode: formData.pincode,
      sfname: formData.sfname,
      customizationId: customizationId,
      cartType: 'giftCard',
    };

    Object.entries(payload).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }
}